export default __webpack_public_path__ + "static/media/plus-sign.2b3314f6.svg";